import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import {
  ButtonGroup,
  Button,
  Stack,
  Pagination,
  Typography,
  Box,
  Drawer,
} from "@mui/material";
import {
  StyledPaper,
  StyledTable,
  StyledTableBody,
  StyledTableCell,
  StyledTableCell2,
  StyledTableContainer,
  StyledTableHead,
  StyledTableRow,
} from "../../CustomComponent/TableCompoent";
import {
  setSelectedMenu,
  getAvailableAgentList,
} from "../../Redux/Actions/actions";
import { BaseUrl, excelDownloadUrl } from "../../Container/BaseUrl/BaseUrl";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { IoIosArrowBack } from "react-icons/io";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import { Hourglass } from "react-loader-spinner";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import FileSaver from "file-saver";

const AgentMartixHeaderDatas = [
  "Agent Name",
  "Total Response Time",
  "Total Resolution Time",
  "FCR",
  "AHT",
  "ABD",
  "Interaction Volume",
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),
};

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

const AgentMatrix = (props) => {
  const selectAgentRef = useRef(null);
  const animatedComponents = makeAnimated();
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [selectedagent, setSelectedagent] = useState("");
  const [loadSpinner, setLoadSpinner] = useState("");
  const [agentMatriclist, setAgentMatriclist] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };
  const filterRef = useRef({
    from_date: fromdate,
    to_date: todate,
    agent_id: selectedagent.value || "",
  });
  const handleSubmit = () => {
    if (!fromdate) {
      setFromDateError(true);
      return;
    } else if (!todate) {
      setToDateError(true);
      return;
    } else if (moment(fromdate).isAfter(todate)) {
      setFromDateError(true);
      return;
    } else {
      filterRef.current = {
        from_date: fromdate ? fromdate : "",
        to_date: todate ? todate : "",
        agent_id: selectedagent.value || "",
      };
      setPage(1);
      agentmetricsApi(1);
      handelCloseFilter();
      setFromDateError(false);
      setToDateError(false);
    }
  };
  const resetButton = () => {
    selectAgentRef.current.clearValue();
    setFromdate(defaultValue);
    setTodate(defaultValue);
    setSelectedagent("");
    setFromDateError(false);
    setToDateError(false);
  };

  const optionsAgent =
    props.DropDownAgentList &&
    props.DropDownAgentList.map((agent) => ({
      value: agent.id,
      label: agent.username,
    }));

  const handleSelectAgentChange = (selectedOptions) => {
    setSelectedagent(selectedOptions);
  };

  const agentmetricsApi = async (pageToFetch) => {
    const { from_date, to_date, agent_id } = filterRef.current;
    setLoadSpinner(true);
    await axios
      .post(
        BaseUrl + "/reports/agentMetrics",
        {
          from_date,
          to_date,
          agent_id,
          limit: 10,
          offset: pageToFetch == 1 ? 0 : (pageToFetch - 1) * 10,
        },

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantid: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setLoadSpinner(true);
        if (res.data.status) {
          setLoadSpinner(false);
          setAgentMatriclist(res.data.Data);
          setPagination(res.data.count);
          toast.success(res.data.message, toaststyle);
        } else {
          setLoadSpinner(false);
          setAgentMatriclist([]);
          setPagination(0);
          toast.warn(res.data.message, toaststyle);
        }
      })
      .catch(() => {
        setLoadSpinner(false);
        setAgentMatriclist([]);
        setPagination(0);
        console.log(error);
      });
  };

  const handleChange = async (event, value) => {
    setPage(value);
    await agentmetricsApi(value);
  };

  useEffect(() => {
    agentmetricsApi(page);
  }, []);

  const agentMetrixDownloadExcel = async () => {
    setIsLoading(true);
    try {
      await axios
        .post(
          BaseUrl + "/reports/agentMetricsexcel",
          {
            from_date: fromdate,
            to_date: todate,
            offset: page === 1 ? 0 : (page - 1) * 10,
            limit: 10,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          setIsLoading(true);
          if (res.data.status) {
            setIsLoading(false);
            let file = excelDownloadUrl + res.data.data;
            window.open(file);
            toast.success(
              "Agent Metrics Report Downloaded Successfully",
              toaststyle
            );
          } else {
            toast.warning("No Data Found", toaststyle);
          }
        });
    } catch (error) {
      setIsLoading(false);
      console.error("Download error:", error);
      toast.warning("No Data Found", toaststyle);
    }
  };

  const agentMetrixDownloadPDF = async () => {
    setIsLoadingPDF(true);
    try {
      await axios
        .post(
          BaseUrl + "/reports/agentMetricspdf",
          {
            from_date: fromdate,
            to_date: todate,
            offset: page === 1 ? 0 : (page - 1) * 10,
            limit: 10,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((response) => {
          setIsLoadingPDF(true);
          if (response.data.status) {
            setIsLoadingPDF(false);
            const downloadEmailasPdf = excelDownloadUrl + response.data.data;
            const customFileName = `agentperformance_report_${fromdate}_to_${todate}.pdf`;
            FileSaver.saveAs(downloadEmailasPdf, customFileName);

            toast.success(
              "Agent Metrics Report Downloaded Successfully",
              toaststyle
            );
          } else {
            setIsLoadingPDF(false);
            toast.warning("No Data Found", toaststyle);
          }
        });
    } catch (error) {
      setIsLoadingPDF(false);
      console.error("Download error:", error);
      toast.warning("No Data Found", toaststyle);
    }
  };
  return (
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Agent Metrics Report
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/* Back btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.setSelectedMenu("ReportMenu");
                }}
              >
                <IoIosArrowBack className="me-2" />
                Back
              </Button>

              {/* Download btn  */}
              {/* Download btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={agentMetrixDownloadExcel}
                disabled={isLoading}
              >
                <DownloadSimple className="me-2" />
                {isLoading ? "Downloading..." : "Download Report"}
              </Button>
              {/* Feature enhancement */}
              {/* <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={agentMetrixDownloadPDF}
                disabled={isLoadingPDF}
              >
                <DownloadSimple className="me-2" />
                {isLoadingPDF ? "Downloading..." : "Download PDF"}
              </Button> */}
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={handelShowFilter}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <StyledTableHead>
                  <StyledTableRow>
                    {AgentMartixHeaderDatas.map((headers) => (
                      <StyledTableCell style={{ minWidth: "150px" }}>
                        {headers}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  {loadSpinner ? (
                    <Stack
                      sx={{ position: "absolute", top: "50%", left: "50%" }}
                    >
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) : agentMatriclist.length > 0 ? (
                    agentMatriclist.map((items, index) => {
                      return (
                        <StyledTableRow id={index} hover role="checkbox">
                          <StyledTableCell2>
                            {items.username ? items.username : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {items.response_time ? items.response_time : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {items.resolution_time
                              ? items.resolution_time
                              : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {items.first_time_resolved_count
                              ? items.first_time_resolved_count
                              : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {items.avg_handling_time
                              ? items.avg_handling_time
                              : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {items.abandoned_count
                              ? items.abandoned_count
                              : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {items.Accept_count ? items.Accept_count : "--"}
                          </StyledTableCell2>
                        </StyledTableRow>
                      );
                    })
                  ) : (
                    <>
                      {/* // Data unavailable start */}
                      <Stack
                        sx={{
                          position: "absolute",
                          width: "100%",
                          height: "calc(100vh - 14rem)",
                        }}
                        justifyContent="center"
                        alignContent="center"
                      >
                        <Stack
                          className="text-muted"
                          direction="column"
                          justifyContent="center"
                          alignContent="center"
                        >
                          <span className="mx-auto">
                            <img
                              src={Nodata}
                              alt="pic"
                              style={{ width: "11rem", userSelect: "none" }}
                            />
                          </span>
                          <span className="mx-auto">
                            <h6
                              className="text-muted mt-3"
                              style={{ fontSize: "13px" }}
                            >
                              Data unavailable
                            </h6>
                          </span>
                        </Stack>
                      </Stack>
                      {/* // Data unavailable end */}
                    </>
                  )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                {`Showing ${Math.min(
                  (page - 1) * 10 + 1,
                  isNaN(pagination) ? 0 : pagination
                )} to ${Math.min(
                  page * 10,
                  isNaN(pagination) ? 0 : pagination
                )} of ${isNaN(pagination) ? 0 : pagination} entries`}
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                variant="outlined"
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="p-2">
                <div className="mb-3 d-flex flex-column text-start">
                  <label for="exampleInputtodate" className="form-label">
                    From Date <small className="text-danger">*</small>
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    id="exampleInputfromdate"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                  {fromDateError && moment(fromdate).isAfter(todate) && (
                    <span
                      className="text-danger mt-2"
                      style={{ fontSize: "10px" }}
                    >
                      From date should be less than To date
                    </span>
                  )}
                  {fromDateError &&
                    !moment(fromdate).isAfter(todate) &&
                    !fromdate && (
                      <span
                        className="text-danger mt-2"
                        style={{ fontSize: "10px" }}
                      >
                        From date is required
                      </span>
                    )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label for="exampleInputtodate" className="form-label">
                    To Date <small className="text-danger">*</small>
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    id="exampleInputtodate"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                  {toDateError &&
                    !moment(defaultValue).isBefore(todate) &&
                    !todate && (
                      <span
                        className="text-danger mt-2"
                        style={{ fontSize: "10px" }}
                      >
                        To date is required
                      </span>
                    )}
                </div>

                <div className="mb-3">
                  <label for="exampleInputfromdate" className="form-label">
                    Agent <small className="text-danger">*</small>
                  </label>
                  <Select
                    ref={selectAgentRef}
                    placeholder="Select Agent"
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    options={optionsAgent}
                    styles={customStyles}
                    defaultValue={selectedagent}
                    onChange={handleSelectAgentChange}
                  />
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={handelCloseFilter}
            >
              Close
            </Button>
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="warning"
              disableElevation
              onClick={resetButton}
            >
              Reset
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer End  */}
    </StyledPaper>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
  getAvailableAgentList,
})(AgentMatrix);
